import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  apartmentWithHoldingsAndLeasesAndSubletsSchema,
  getApartmentWithHoldingsAndLeasesAndSubletsSchemaWithAdditionalFields,
} from "./apartment-with-holdings-and-leases-and-sublets";
import {
  getHoldingWithApartmentAndSubletsSchemaWithAdditionalFields,
  holdingWithApartmentAndSubletsSchema,
} from "./holding-with-apartment-and-sublets";
import { issueFastumTicketSchema } from "./issue-fastum-ticket";
import { issueWithCreatedByAndLinksAndChildrenAndParentSchema } from "./issue-with-created-by-and-links-and-children-and-parent";
import {
  getLeaseWithApartmentAndSubletsSchemaWithAdditionalFields,
  leaseWithApartmentAndSubletsSchema,
} from "./lease-with-apartment-and-sublets";
import {
  getOrganizationWithHoldingsAndLeasesAndSubletsAndApartmentSchemaWithAdditionalFields,
  organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
} from "./organization-with-holdings-and-leases-and-sublets-and-apartment";
import {
  getPersonWithHoldingsAndLeasesAndSubletsAndApartmentSchemaWithAdditionalFields,
  personWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
} from "./person-with-holdings-and-leases-and-sublets-and-apartment";
import {
  getSubletWithApartmentSchemaWithAdditionalFields,
  subletWithHoldingOrLeaseAndApartmentSchema,
} from "./sublet-with-holding-or-lease-and-apartment";

export const issueWithCreatedByAndLinksAndChildrenAndParentAndRegistersSchema =
  issueWithCreatedByAndLinksAndChildrenAndParentSchema.extend({
    apartments: z
      .array(apartmentWithHoldingsAndLeasesAndSubletsSchema)
      .default([]),
    holdings: z.array(holdingWithApartmentAndSubletsSchema).default([]),
    leases: z.array(leaseWithApartmentAndSubletsSchema).default([]),
    sublets: z.array(subletWithHoldingOrLeaseAndApartmentSchema).default([]),
    persons: z
      .array(personWithHoldingsAndLeasesAndSubletsAndApartmentSchema)
      .default([]),
    organizations: z
      .array(organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema)
      .default([]),
    fastumTickets: z.array(issueFastumTicketSchema).default([]),
  });

export type IssueWithCreatedByAndLinksAndChildrenAndParentAndRegisters =
  z.infer<
    typeof issueWithCreatedByAndLinksAndChildrenAndParentAndRegistersSchema
  >;

export function getIssueWithCreatedByAndLinksAndChildrenAndParentAndRegistersSchemaWithAdditionalFields(additionalFields: {
  apartment: typeof additionalDataSchema;
  holding: typeof additionalDataSchema;
  lease: typeof additionalDataSchema;
  sublet: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
}): typeof issueWithCreatedByAndLinksAndChildrenAndParentAndRegistersSchema {
  return issueWithCreatedByAndLinksAndChildrenAndParentSchema
    .merge(issueWithCreatedByAndLinksAndChildrenAndParentAndRegistersSchema)
    .extend({
      apartments: z
        .array(
          getApartmentWithHoldingsAndLeasesAndSubletsSchemaWithAdditionalFields(
            additionalFields,
          ),
        )
        .default([]),
      holdings: z
        .array(
          getHoldingWithApartmentAndSubletsSchemaWithAdditionalFields(
            additionalFields,
          ),
        )
        .default([]),
      leases: z
        .array(
          getLeaseWithApartmentAndSubletsSchemaWithAdditionalFields(
            additionalFields,
          ),
        )
        .default([]),
      sublets: z
        .array(
          getSubletWithApartmentSchemaWithAdditionalFields(additionalFields),
        )
        .default([]),
      persons: z
        .array(
          getPersonWithHoldingsAndLeasesAndSubletsAndApartmentSchemaWithAdditionalFields(
            additionalFields,
          ),
        )
        .default([]),
      organizations: z
        .array(
          getOrganizationWithHoldingsAndLeasesAndSubletsAndApartmentSchemaWithAdditionalFields(
            additionalFields,
          ),
        )
        .default([]),
    });
}
